var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StateAnalysis',{attrs:{"title":"情绪评价报告","report":"qxReportHistories"}})
}
var staticRenderFns = []

export { render, staticRenderFns }